function Library_form_edit(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    checkboxPublished: '.js-checkbox-published',
	    containerPublishing: '.js-container-publishing'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded'
    };

    this.init = function() {
	    this.$checkboxPublished = this.$element.find(this.selectors.checkboxPublished);

	    if (this.$checkboxPublished.length) {
		    this.$formParent = this.$element.parents(this.selectors.formParent);
		    this.$containerPublishing = this.$element.find(this.selectors.containerPublishing);

			this.$checkboxPublished.on('i4:change', this.$onChangePublishing.bind(this));

			this.$formParent.on(this.triggers.afterLoaded, (function() {
				this.$onChangePublishing();
			}).bind(this));
		}
    };

    this.$onChangePublishing = function() {
    	if (this.$checkboxPublished.is(':checked')) {
			this.$containerPublishing.show();
		} else {
			this.$containerPublishing.hide();
		}
    };
}
